module.exports = "/images/global.svg?659bc4517529037525a0982dfeea05aa";